export const getDefaultRestockLocation = (locations, defaultRestockLocationId) => {
  if (locations?.length === 1) {
    return locations[0].id
  }

  if (defaultRestockLocationId) {
    const location = locations?.find(location => location.id === defaultRestockLocationId)
    return location?.id || null
  }

  return null
}
